import { NgClass } from '@angular/common';
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import {PopoverService} from "../../../app/services/popover.service";

@Component({
	selector: 'mos-popover',
	exportAs: 'mosPopover',
	templateUrl: './popover.component.html',
	styleUrl: './popover.component.css',
	imports: [NgClass],
	standalone: true,
})
export class PopoverComponent {
	@Input() public buttonText: string;
	@Input() public position?: 'top' | 'bottom' | 'left' | 'right';
	@Input() public align?: 'start' | 'middle' | 'end';
	public isOpen = false;
	public popoverData: any;
	@Input() role?: string = "tooltip";
	@Input() popoverId?: string;
	@Input() modal?: boolean;

	constructor(private elementRef: ElementRef, private popoverService: PopoverService) {}

	public open(event: MouseEvent, popoverData?: any): void {
		event.preventDefault();
		event.stopPropagation();
		this.show(popoverData);
	}

	public show(popoverData?: any) {
		this.popoverData = popoverData;
		this.isOpen = !this.isOpen;
		if (this.isOpen) {
			this.popoverService.register(this);
		} else {
			this.popoverService.unregister(this);
		}
	}

	public dynamicClasses() {
		const classes = { 'tw-hidden': !this.isOpen };
		if (this.position) {
			classes['popover-' + this.position] = true;
		}
		if (this.align) {
			classes[`align-${this.align}-${this.position}`] = true;
		}
		return classes;
	}

	public close() {
		this.isOpen = false;
		this.popoverService.unregister(this);
	}

	public toggle(event?: MouseEvent, popoverData?: any): void {
		if (this.isOpen) {
			this.close();
		} else {
			if (event) this.open(event, popoverData);
			else this.show(popoverData);
		}
	}

	@HostListener('document:click', ['$event'])
	public clickOutside(event: any): void {
		const target = event.target as HTMLElement;
		const hostEl = this.elementRef.nativeElement;

		// If clicked inside popover we can ignore it
		if (hostEl.contains(target)) return;

		// If clicked inside a CDK overlay we can ignore it
		if (target.closest('.cdk-overlay-container')) return;

		// Check if click is inside any other open popover
		const openPopovers = this.popoverService.getOpenPopovers();
		for (const popover of openPopovers) {
			if (popover !== this && popover['elementRef']?.nativeElement.contains(target)) {
				return;
			}
		}

		this.close();
	}
}
